// extracted by mini-css-extract-plugin
export default {"TabsWrapper":"TabsWrapper_TabsWrapper__3GH2t"};